import { createSelector } from "reselect";
import { adminSectionSelector } from "../admin_section_selector";

export const admissionStatusFilterSelector = createSelector(
  adminSectionSelector,
  adminSection => {
    return adminSection.admissionStatusFilter;
  }
);
